import { Dimensions, Segment, TimeRange } from '@mi-front/core';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import React, { ComponentType, PropsWithChildren } from 'react';
import { NotificationsContainer } from '../components/notifications/NotificationsContainer';
import { SegmentsStream } from '../components/stream/stream/SegmentsStream';

export const svgStreamDecorator =
  (args: Dimensions & TimeRange<number>) => (story: (...args: any) => any) => (
    <SegmentsStream
      segments={[]}
      range={pick(args, 'from', 'to')}
      width={args.width}
      height={args.height}
      renderSvg={() => story()}
      renderHtml={() => null}
    />
  );

export const streamDecorator =
  (args: Dimensions & TimeRange<number> & { segments?: readonly Segment[] }) =>
  (story: (...args: any) => any) => (
    <SegmentsStream
      segments={args.segments || []}
      range={pick(args, 'from', 'to')}
      width={args.width}
      height={args.height}
      renderSvg={() => null}
      renderHtml={() => story()}
    />
  );

export const notificationsDecorator =
  (p = {}) =>
  (story: (...args: any) => any) => (
    <React.Fragment>
      <NotificationsContainer {...p} />
      {story()}
    </React.Fragment>
  );

export function withCtxProvider<T>(
  Provider: ComponentType<{ value: T; children?: React.ReactNode }>,
  value: T,
) {
  return (story: (...args: any) => any) => {
    return <Provider value={value}>{story()}</Provider>;
  };
}

export function ContainerDiv(p: PropsWithChildren<React.CSSProperties & { className?: string }>) {
  return (
    <div
      id="container-div"
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        padding: 16,
        ...omit(p, ['className']),
      }}
      className={p.className}
    >
      {p.children}
    </div>
  );
}

export const containerDiv =
  (p: React.CSSProperties & { className?: string } = {}) =>
  (storyFn: (...args: any) => any) => <ContainerDiv {...p}>{storyFn()}</ContainerDiv>;

export function screenDecorator(storyFn: (...args: any) => any) {
  return (
    <div className="root-wrapper">
      <div className="sidenav-wrapper" />
      <div className="content-wrapper">{storyFn()}</div>
    </div>
  );
}
